var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('v-main',{staticClass:"table-index"},[(!_vm.itemsExist)?_c('EmptyBox'):_c('ContentBox')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }